import React, { useEffect, useRef, useState } from 'react';

const MessageList = ({ messages }) => {
    const bottomRef = useRef(null);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    useEffect(() => {
        if (bottomRef.current) {
            bottomRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
        //console.log("Rendering MessageList with messages:", messages);
    }, [messages]);


    const formatTime = (timestamp) => {
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) return ''; // Invalid date fallback
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    return (
        <div
            style={{
                height: '75%',
                padding: screenWidth <= 1000 ? '20px' : '10px',
                overflowY: 'auto',
                backgroundColor: '#f5f5f5',
                fontSize: screenWidth <= 1000 ? '40px' : '16px',
                borderRadius: '8px',
            }}
        >
            {messages.map((msg, index) => {
                const isMine = msg.isMine;
                return (
                    <div
                        key={index}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: isMine ? 'flex-end' : 'flex-start',
                            marginBottom: '10px',
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: isMine ? '#007bff' : '#e4e6eb',
                                color: isMine ? '#fff' : '#000',
                                padding: screenWidth <= 1000 ? '20px' : '10px',
                                borderRadius: isMine ? '15px 15px 0 15px' : '15px 15px 15px 0',
                                maxWidth: '70%',
                                wordBreak: 'break-word',
                            }}
                        >
                            {typeof msg.text === 'string' && /<\/?[a-z][\s\S]*>/i.test(msg.text) ? (
                                <div dangerouslySetInnerHTML={{ __html: msg.text }} />
                            ) : (
                                <span>{msg.text}</span>
                            )}
                        </div>

                        <span style={{ fontSize: screenWidth <= 1000 ? '30px' : '0.75rem', color: '#666', marginTop: '3px' }}>
                            {isMine ? '' : 'Sara |'}{formatTime(msg.created_at || new Date())}
                        </span>
                    </div>
                );
            })}
            <div ref={bottomRef} style={{ marginBottom: '5px' }}></div>
        </div>
    );
};

export default MessageList;
